const user = {
  userId: '',
  permissions: '',
};
export default user;
